import React from 'react';

import {MainLayout} from 'widgets/layout';
import {PromoCodes} from 'features/admin';

const AdminPromoCodesPage: React.FC = () => {

    return (
        <MainLayout>
            <PromoCodes />
        </MainLayout>
    );
};

export default AdminPromoCodesPage;
